export default "__VITE_ASSET__Ce9mkq7V__"